type SupportedApi =
  | 'client'
  | 'employee'
  | 'service'
  | 'product'
  | 'financial'
  | 'notification';

export type OfflineAction = {
  id: string;
  api: SupportedApi;
  method: 'get' | 'post' | 'put' | 'patch' | 'delete';
  url: string;
  payload?: unknown;
  description?: string;
  createdAt: number;
  retries: number;
};

export type QueueActionInput = Omit<OfflineAction, 'id' | 'createdAt' | 'retries'> & {
  id?: string;
};

const STORAGE_KEY = 'ahk-offline-queue';
const MAX_ITEMS = 100;

const readQueue = (): OfflineAction[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed;
  } catch (error) {
    console.warn('[offlineQueue] Falha ao ler fila:', error);
    return [];
  }
};

const persistQueue = (queue: OfflineAction[]) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(queue.slice(-MAX_ITEMS)));
  } catch (error) {
    console.warn('[offlineQueue] Falha ao salvar fila:', error);
  }
};

export const getQueuedActions = (): OfflineAction[] => {
  return readQueue();
};

export const enqueueAction = (input: QueueActionInput): OfflineAction => {
  const queue = readQueue();
  const action: OfflineAction = {
    id: input.id || crypto.randomUUID(),
    createdAt: Date.now(),
    retries: 0,
    ...input,
  };
  queue.push(action);
  persistQueue(queue);
  return action;
};

export const removeAction = (id: string) => {
  const queue = readQueue().filter((item) => item.id !== id);
  persistQueue(queue);
};

export const replaceAction = (updated: OfflineAction) => {
  const queue = readQueue().map((item) => (item.id === updated.id ? updated : item));
  persistQueue(queue);
};

export const clearQueue = () => {
  persistQueue([]);
};

